module.exports = __webpack_public_path__ + "img/team-name-2.b59bbce4.png";